// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__pJVoN","checkbox":"Checkbox_checkbox__82CvA","check":"Checkbox_check__CCymx","label":"Checkbox_label__Hs+kv"};